var map = {
	"./arrow-left-circle.svg": "h9Y7",
	"./arrow-left.svg": "SFIA",
	"./asset.svg": "sxCb",
	"./astra-bookmark.svg": "GXne",
	"./astra-logo.svg": "FLZ4",
	"./bin.svg": "jEpk",
	"./bubble.svg": "7k0e",
	"./building.svg": "vjBF",
	"./calendar.svg": "3Nbk",
	"./cancel.svg": "l6LX",
	"./checked.svg": "jGn8",
	"./checkmark.svg": "wotZ",
	"./chevron-right.svg": "dLUD",
	"./circle.svg": "DC6F",
	"./cross.svg": "k9GA",
	"./csv.svg": "Eju1",
	"./deadline.svg": "BFwi",
	"./doc.svg": "JFeY",
	"./dollar.svg": "caW8",
	"./down-arrow.svg": "EtGO",
	"./download-arrow.svg": "P4vp",
	"./enquiry-add.svg": "O1Oh",
	"./enquiry.svg": "ouEK",
	"./envelope.svg": "m4SL",
	"./excel.svg": "sWjn",
	"./feedback.svg": "iiyF",
	"./file-text.svg": "QCd0",
	"./files.svg": "uK/m",
	"./filter.svg": "En+b",
	"./flag.svg": "IjyR",
	"./gif.svg": "lClp",
	"./greencare.svg": "FcAF",
	"./group.svg": "G8Va",
	"./history.svg": "iDeL",
	"./info-1.svg": "Ph1b",
	"./info-2.svg": "FYU3",
	"./info.svg": "XIu3",
	"./keyboard_arrow_sort.svg": "uSGj",
	"./layers.svg": "YGh9",
	"./line.svg": "VeCx",
	"./link.svg": "sAHT",
	"./link_out.svg": "DJxt",
	"./location.svg": "CynE",
	"./locations.svg": "7P8y",
	"./locked.svg": "o0rf",
	"./log-out.svg": "SABZ",
	"./loop.svg": "6mZG",
	"./mail-checked.svg": "vLN1",
	"./maplocation.svg": "4FVv",
	"./minus.svg": "QT2L",
	"./niraslogo.svg": "3wch",
	"./paper-plane.svg": "VSIF",
	"./pathpoint.svg": "j9q+",
	"./pdf.svg": "4bXS",
	"./pencil.svg": "QtaU",
	"./phone.svg": "tegb",
	"./pictures.svg": "LIf4",
	"./plus.svg": "RtHv",
	"./powerpoint.svg": "iBmR",
	"./ppt.svg": "hCSE",
	"./printer.svg": "Uk3s",
	"./properties.svg": "jzC2",
	"./property.svg": "gA4H",
	"./repeat.svg": "nqcK",
	"./request.svg": "ucsl",
	"./requisition.svg": "/jWd",
	"./resend.svg": "ZD2b",
	"./round.svg": "iiXG",
	"./routine.svg": "dm1D",
	"./settings.svg": "dmzZ",
	"./sewer.svg": "inSd",
	"./share.svg": "CUmr",
	"./speechbubble.svg": "eP51",
	"./streetlights.svg": "shJj",
	"./supply-type.svg": "ZCeR",
	"./task-add.svg": "w5ay",
	"./task-check.svg": "OOW2",
	"./task-routine.svg": "VsBK",
	"./task-send.svg": "KGlF",
	"./task.svg": "tKhF",
	"./template-add.svg": "Sf4n",
	"./template.svg": "l48A",
	"./trash.svg": "FapF",
	"./triangle-down.svg": "Dby3",
	"./txt.svg": "YRnR",
	"./unknown.svg": "5iXr",
	"./up-arrow.svg": "H2uT",
	"./upload.svg": "OWkb",
	"./user-anon.svg": "0mht",
	"./user-reverse-helmet.svg": "/mOE",
	"./user-reverse.svg": "Y5tN",
	"./user.svg": "fP5l",
	"./water.svg": "7O0Z",
	"./weather.svg": "9XsD",
	"./word.svg": "wyj0",
	"./xls.svg": "XJlM",
	"./xml.svg": "2RFX",
	"./zip.svg": "kNsC"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5lmF";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg ^\.\/.*\.svg$
// module id = 5lmF
// module chunks = 1